// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //apiUrl: "http://192.168.2.101/more_than_friends/v1/admin/",
  //ImageUrl: "http://192.168.2.101/more_than_friends/media/"
  // apiUrl: "https://demo.ezzysales.com/more_than_friends/v1/admin/",
  // ImageUrl: "https://demo.ezzysales.com/more_than_friends/media/"
  apiUrl: "http://more-than-friends-api.microwix.com/v1/admin/",
  ImageUrl: "http://more-than-friends-api.microwix.com/media/"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
